<template>
    <div>
        <legend>Группы клиентов</legend>
        <dx-data-grid
                :show-borders="true"
                :data-source="dataSource"
                :remote-operations="true"
                @row-inserted="$root.$emit('PARTNER_GROUPS_CHANGED')"
                @row-updated="$root.$emit('PARTNER_GROUPS_CHANGED')"
                @row-removed="$root.$emit('PARTNER_GROUPS_CHANGED')"
        >
            <dx-editing
                    :allow-updating="true"
                    :allow-deleting="true"
                    :allow-adding="true"
                    mode="row"
            />
            <dx-column
                    data-field="Name"
                    caption="Название"
            />
        </dx-data-grid>
    </div>
</template>
<script>
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { DxColumn, DxDataGrid, DxEditing } from 'devextreme-vue/data-grid';
import token from '@/admin/services/token';

const url = `${process.env.VUE_APP_API_HOST}admin/customer-group`;
const dataSource = createStore({
  key: 'Id',
  loadUrl: `${url}`,
  insertUrl: `${url}/insert`,
  updateUrl: `${url}/update`,
  deleteUrl: `${url}/delete`,
  onBeforeSend(operation, ajaxOptions) {
    ajaxOptions.headers = {
      Authorization: `Bearer ${token}`,
    };
  },
  // onBeforeSend: (method, ajaxOptions) => {
  // ajaxOptions.xhrFields = { withCredentials: true };
  // },
});
export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
  },
  data() {
    return {
      dataSource,
    };
  },
  mounted() {
  },
};
</script>
